type YoutubeThumbnailResolution = 'default' | 'medium' | 'high' | 'standard' | 'maxres';

/**
 * Generates thumbnail image of youtube video
 * @param videoId
 * @param resolution
 * @returns url
 *
 * @see https://developers.google.com/youtube/v3/docs/thumbnails#resource-representation
 */
function youtubeThumbnailGenerator(
  videoId: string,
  resolution: YoutubeThumbnailResolution = 'default'
) {
  return `https://img.youtube.com/vi/${videoId}/${resolution}.jpg`;
}

export { youtubeThumbnailGenerator };
